import React from "react";
import Lottie from "react-lottie";
import loadingBrain from "../../assets/images/loading-brain.json";
import loadingWheel from "./loading-wheel.json";
import loaderFullPageStyle from "./loader-full-page.scss";

interface LoaderFullPageProps {
  enabled: boolean;
  message?: string;
}

export const LoaderFullPage: React.FC<LoaderFullPageProps> = ({
  enabled,
  message,
}) => {
  if (enabled) {
    const withMessage = !!message;
    return (
      <div className="loader-background">
        <style jsx>{loaderFullPageStyle}</style>
        {withMessage ? (
          <div className="message-card">
            <div className="spinner">
              <Lottie
                width="100px"
                options={{
                  animationData: loadingBrain,
                  loop: true,
                  autoplay: true,
                }}
              />
            </div>
            <p className="message">{message}</p>
          </div>
        ) : (
          <div className="loader-wrapper">
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingWheel,
              }}
            />
          </div>
        )}
      </div>
    );
  }

  return null;
};
